import { get, put, remove, post } from "../../utils/httpClient";

const boardService = () => {
  const prefixApi = "duedates/boards";

  const getBoard = async (id) => {
    return await get(`/${prefixApi}/${id}`);
  };

  const getBoards = async () => {
    return await get(`/${prefixApi}`);
  };

  const getBoardSettings = async () => {
    return await get(`/${prefixApi}/settings`);
  };

  const getBoardCustomFields = async (id) => {
    return await get(`/${prefixApi}/${id}/custom-fields`);
  };

  const createBoard = async (json) => {
    return await post(`/${prefixApi}`, json);
  };

  const updateBoard = async (json) => {
    return await put(`/${prefixApi}`, json);
  };

  const deleteBoard = async (id) => {
    return await remove(`/${prefixApi}/${id}`);
  };

  const getBoardPermissions = async (id, includeUnsubscribed = false) => {
    return await get(`/${prefixApi}/${id}/permissions`, {
      includeUnsubscribed,
    });
  };

  const getUserBoardPermissions = async () => {
    return await get(`/${prefixApi}/permissions`);
  };

  const updateBoardPermissions = async (json) => {
    return await put(`/${prefixApi}/permissions`, json);
  };

  const createBoardPermission = async (json) => {
    return await post(`/${prefixApi}/permissions`, json);
  };

  const requestBoardAccess = async (json) => {
    return await post(`/${prefixApi}/request-access`, json);
  };

  return {
    getBoard,
    getBoards,
    getBoardPermissions,
    getBoardCustomFields,
    updateBoardPermissions,
    getUserBoardPermissions,
    getBoardSettings,
    updateBoard,
    createBoard,
    deleteBoard,
    createBoardPermission,
    requestBoardAccess,
  };
};

export default boardService;
